import { useTranslationUserProfiles } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { memo } from 'react';
import { HeaderBar } from '@dealstack/frontend/shared/components/HeaderBar/HeaderBar';
import { ManagePIVDetails } from '@dealstack/frontend/shared/components/Profile/PIVDetails/ManagePIVDetails/ManagePIVDetails';

const PIVDetails = () => {
	const tUserProfiles = useTranslationUserProfiles();
	return (
		<div>
			<HeaderBar tabSectionName={tUserProfiles('piv.company_details')}></HeaderBar>
			<ManagePIVDetails />
		</div>
	);
};
const _PIVDetailsExport = memo(PIVDetails);

export { _PIVDetailsExport as PIVDetails };
